import { useState } from 'react'
import Icon from 'rv-components/react/Icon'
import Text from 'components/Text'
import Button from 'components/Button'
import useMediaQuery from 'hooks/useMediaQuery'
import './LandingEmail.styl'

const LandingEmail = ({ blok }) => {
  const isNotMobile = useMediaQuery('notMobile')

  const [email, setEmail] = useState('')

  return (
    <div
      className="landing-email-container"
      style={{
        backgroundImage: `url(${blok.background_image.filename.replace(
          'https://a.storyblok.com',
          'https://assets.renegocie.cartoes.itau.com.br'
        )})`,
      }}
    >
      <div className="landing-email-content">
        <Text p size={1} className="label-text">
          {blok.top_text}
        </Text>
        <div className="input-container">
          <input
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={blok.placeholder_text}
            className="input"
          />
          <Button className="button">
            {isNotMobile ? (
              blok.button_text
            ) : (
              <div className="button-icon">
                <Icon iconId={'iconLPemail'} />
              </div>
            )}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default LandingEmail
